(() => {
  if (window.pcdProductCard) return;
  window.pcdProductCard = true;

  // Bolletje op de knop: hoeveel van dit product al in de winkelwagen zit
  const updateCounts = (cart) => {
    const totals = {};
    cart.items.forEach((item) => {
      totals[item.product_id] = (totals[item.product_id] || 0) + item.quantity;
    });

    document.querySelectorAll('[data-pcd-product]').forEach((button) => {
      const count = button.querySelector('[data-pcd-atc-count]');
      if (!count) return;
      const quantity = totals[button.dataset.pcdProduct] || 0;
      count.textContent = quantity > 99 ? '99+' : quantity;
      count.hidden = quantity === 0;
    });
  };

  const refreshCounts = async () => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (response.ok) updateCounts(await response.json());
    } catch (error) {
      // Niet kritiek: het bolletje blijft op de laatste stand staan
    }
  };

  // Zelfde flow als card-product: toevoegen en de cart-drawer openen
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pcd-atc]');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    event.preventDefault();
    button.classList.add('is-loading');

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.pcdAtc), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
        }),
      });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || response.status);

      refreshCounts();

      const cart = document.querySelector('cart-drawer');
      if (cart) {
        cart.renderContents(state);
        cart.classList.remove('is-empty');
        document.dispatchEvent(new CustomEvent('cart-drawer-update'));
        cart.open();
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      console.error('PCD add to cart:', error);
    } finally {
      button.classList.remove('is-loading');
    }
  });

  // Aantal aanpassen of verwijderen in de cart-drawer
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCounts);
  }

  // Terug naar de pagina via de browsercache: winkelwagen kan intussen veranderd zijn
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCounts();
  });
})();
